import { Text, Stack } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import payPalLogo from '../../resources/images/paypal.svg';
import type { PaymentMethod } from '~/subscription-management/api/common/model/payment-method';

interface Props {
  paymentDetails: PaymentMethod<'PAYPAL'>['details'];
  withLogo?: boolean;
}

export function PayPalInfo({ paymentDetails, withLogo = false }: Props): JSX.Element | null {
  const { t } = useTranslationWithPrefix('checkout:wizard.review-order.payment-details');

  if (withLogo) {
    return (
      <Stack spacing="x1">
        <img src={payPalLogo} alt="PayPal" />
        <Text textType="caption">
          {t('account')}: {paymentDetails.email}
        </Text>
      </Stack>
    );
  }

  return <Text textType="caption">{paymentDetails.email}</Text>;
}
